import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RuntimeConfigService } from '../../../services/runtime-config.service';
import {
  ImpersonationAuditParticipants,
  ImpersonationAuditQueryParams,
  ImpersonationAuditResult
} from './models/impersonation-audit.model';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationLogsService {
  private apiUrl: string;

  constructor(private http: HttpClient, private runtimeConfig: RuntimeConfigService) {
    this.apiUrl = this.runtimeConfig.currentConfig.apiUrl + '/impersonationaudit';
    this.runtimeConfig.config$.subscribe(config => {
      this.apiUrl = config.apiUrl + '/impersonationaudit';
    });
  }

  getLogs(query: ImpersonationAuditQueryParams): Observable<ImpersonationAuditResult> {
    let params = new HttpParams()
      .set('page', query.page)
      .set('pageSize', query.pageSize);

    if (query.sortField) params = params.set('sortField', query.sortField);
    if (query.sortDir) params = params.set('sortDir', query.sortDir);
    if (query.realUserId != null) params = params.set('realUserId', query.realUserId);
    if (query.impersonatedUserId != null) params = params.set('impersonatedUserId', query.impersonatedUserId);

    return this.http.get<ImpersonationAuditResult>(`${this.apiUrl}/GetLogs`, { params });
  }

  getParticipants(): Observable<ImpersonationAuditParticipants> {
    return this.http.get<ImpersonationAuditParticipants>(`${this.apiUrl}/GetParticipants`);
  }
}
